var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Highcharts',{ref:_vm.id,staticStyle:{"border-radius":"8px"},attrs:{"options":_vm.chartOpt}})}
var staticRenderFns = []

export { render, staticRenderFns }